import React, { PropsWithChildren } from 'react'
import { Accordion } from '../Accordion'
import { AccordionPanel } from '../Accordion/AccordionPanel'
import { Column } from '../Column'
import { FadeInWhenVisible } from '../FadeInWhenVisible'
import classes from './detailVerticalTab.module.scss'
import { TabsProps } from './types'


const ResponsiveDetailTabs: React.FC<PropsWithChildren<TabsProps>> = ({ data }) => (
  <div className={classes.responsiveContainer}>
    <AccordionPanel>
      <FadeInWhenVisible animation={'easySlidingUpFadeOut'}>
        <h2>{data.title}</h2>
      </FadeInWhenVisible>
      <Accordion>
        {data?.tabList && data?.tabList?.length > 0 &&
          data.tabList.map((item, idx: number) => (
            <Accordion key={idx} panel i={idx + 1}>
              <Accordion title>
                <FadeInWhenVisible animation={'easyFadeIn'}>
                  {item}
                </FadeInWhenVisible>
              </Accordion>
              <Accordion content>
                <div className={classes.columnsContainerResp}>
                  <FadeInWhenVisible className={classes.columnMotion} animation={'easyFadeIn'}>
                    <h3>{data?.tabContent[idx]?.title}</h3>
                    <div className={classes.columns}>
                      {data?.tabContent?.[idx]?.content && data?.tabContent[idx]?.content?.map((content, idx) => (
                        <Column className={classes.column} body={{ content: content?.body?.content }} key={idx} href={''} variant={'default'} src={{
                          filename: '',
                          alt: '',
                        }} component={'column'} _uid={''} size={'default'} align={'center'} full_width={true} mob_size={'default'} />
                      ))}
                    </div>
                    <div className={classes.columns}>
                      {data?.tabContent?.[idx]?.lowerContent && data?.tabContent[idx]?.lowerContent?.map((content, idx) => (
                        <Column className={classes.column} body={{ content: content?.body?.content }} key={idx} href={''} variant={'default'} src={{
                          filename: '',
                          alt: '',
                        }} component={'column'} _uid={''} size={'default'} align={'center'} full_width={true} mob_size={'default'} />
                      ))}
                    </div>
                  </FadeInWhenVisible>
                </div>
              </Accordion>
            </Accordion>
          ))}
      </Accordion>
    </AccordionPanel>
  </div>
)

export default ResponsiveDetailTabs